import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { AccountService } from '../../services/api/account.service';
import { CONSTANTS } from '../../constants';
import { DataService } from '../../services/data.service';
import { DateUtil } from '../../utils/date.utils';
import { JqueryUtils } from '../../utils/jquery.utils';
import { NotificationService } from '../../services/notification.service';
import { ReportService } from '../../services/api/report.service';
import { SymbolService } from '../../services/api/symbol.service';
import { ThreadService } from '../../services/api/thread.service';
import { rejects } from 'assert';

@Component({
  selector: 'app-report-alerts',
  templateUrl: './report-alerts.component.html',
  styleUrls: ['./report-alerts.component.scss']
})
export class ReportAlertsComponent implements OnInit {

  admin: any;
  reports: any = [];
  users: any = [];
  categories: any = [];
  segments: any = [];
  user_strategies: any = { "-1": [{ _id: "-1", display_name: "Select", strategy: { name: "" } }] };
  deletion_report: any = {};
  enableParams: any = {};
  save_modal_report: any = {
    header: '',
    btn_text: '',
    report: {},
  };
  view_modal_report: any = {
    report: {},
  };
  select_symbol_params: any = { };
  periods: any = [
    { _id: 'daily', name: 'Daily' },
    { _id: 'monthly', name: 'Monthly' }
  ];
  input_types: any = [
    { _id: 'order_matching', name: 'Order Matching' },
    { _id: 'state_file', name: 'State File' },
    { _id: 'manual', name: 'Manual' }
  ];
  entry_types: any = [
    { _id: 'buy', name: 'BUY' },
    { _id: 'sell', name: 'SELL' }
  ];

  report_modal_form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    period: new FormControl('', [Validators.required]),
  });

  constructor(private accountService: AccountService, private dataService: DataService, private dateUtil: DateUtil,
    private jq: JqueryUtils, private reportService: ReportService, private notificationService: NotificationService,
    private symbolService: SymbolService, private threadService: ThreadService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.REPORT_ALERTS});
    this.loadCategories();
    this.loadSegments();
    this.listUsers(() => {
      // console.log(new Date() + 'Loading Reports');
      this.listReports();
    });
  }

  listUsers(cb: any = null) {
    this.accountService.listAccounts().subscribe((response: any) => {
      this.users = [{ user: { _id: "-1", full_name: "Select" } }];
      response.accounts.forEach((e: any) => {
        this.users.push(e);
      });;
      if (cb != null) {
        cb();
      }
    });
  }

  listReports() {
    let ip: any = {};
    this.reportService.list(ip).subscribe((response: any) => {
      // console.log(new Date() + 'Loaded Reports');
      this.loadReports(response.reports).then((updated_reports: any) => {
        // console.log(new Date() + 'Loaded Updated Reports');
        this.reports = updated_reports;
      });
    });
  }

  listUserStrategies(user: any, cb: any) {
    if (!this.user_strategies[user.user._id]) {
      let data = { count_per_page:10, page_num:1, acc_id:user._id, display_for:'web_main_list' }
      this.threadService.list(data).subscribe((response: any) => {
        this.user_strategies[user.user._id] = response.threads;
        if (cb) {
          cb();
        }
      });
    } else {
      if (cb) {
        cb();
      }
    }
  }

  loadCategories() {
    let categories: any = this.dataService.getCategories();
    if (categories.length == 0) {
      this.symbolService.getCategories().subscribe((response: any) => {
        if (response.response_code == 1000) {
          categories = [CONSTANTS.DEFAULT.CATEGORY]
          for (let i = 0; i < response.categories.length; i++) {
            let category = response.categories[i]
            categories.push({
              _id: category.toLowerCase(),
              name: category,
            })
          }
          this.dataService.setCategories(categories);
          this.categories = categories;
        }
      });
    } else {
      this.categories = categories;
    }
  }

  loadSegments() {
    let segments: any = this.dataService.getSegments();
    if (segments.length == 0) {
      this.symbolService.getSegments().subscribe((response: any) => {
        if (response.response_code == 1000) {
          let segments = [CONSTANTS.DEFAULT.SEGMENT]
          for (let i = 0; i < response.segments.length; i++) {
            let segment = response.segments[i]
            segments.push({
              _id: segment.toLowerCase(),
              name: segment,
            })
          }
          this.dataService.setSegments(segments);
          this.segments = segments;
        }
      });
    } else {
      this.segments = segments;
    }
  }

  listSymbols(data: any, cb: any) {
    // this.symbolService.getContracts(data).subscribe((response: any) => {
    //   let symbols: any = [CONSTANTS.DEFAULT.SYMBOL];
    //   for (let i = 0; i < response.instruments.length; i++) {
    //     let symbol_obj = response.instruments[i];
    //     symbols.push({
    //       _id: symbol_obj.tradingsymbol.zerodha.toLowerCase(),
    //       name: symbol_obj.name,
    //       tradingsymbol: symbol_obj.tradingsymbol.zerodha,
    //       original: symbol_obj
    //     })
    //   }
    //   if (cb) {
    //     cb(symbols)
    //   }
    // });
  }

  get_report_data(report: any, date: any, cb: any) {
    let ip: any = { report_id: report.report_id, date: date };
    this.reportService.get_report_data(ip).subscribe((response: any) => {
      if (cb) {
        cb(response);
      }
    });
  }

  toReportRow(report: any) {
    let strategies: any = [];
    for (let idx = 0; idx < report.strategies.length; idx ++) {
      report.strategies[idx].entry_type = report.strategies[idx].entry_type
      ? report.strategies[idx].entry_type
      : this.get_entry_type(this.getStrategyByUserStrategy(report.strategies[idx].user_id, report.strategies[idx].thread_id));
      strategies.push(report.strategies[idx]);
    }
    return {
      report_id: report.report_id,
      name: report.name,
      type: this.getPeriodById(report.type),
      enabled: report.status == 'active',
      strategies: report.strategies,
    };
  }

  loadReports(reports: any) {
    const promise = new Promise<void>((resolve, reject) => {
      let updated_reports: any = [];
      let loadReport = (idx: any) => {
        if ((idx + 1) > reports.length) {
          resolve(updated_reports);
        } else {
          // console.log(new Date() + 'Loading report - ' + idx);
          this.loadReport(reports[idx]).then((report: any) => {
            report = this.toReportRow(report);
            updated_reports.push(report);
            idx = idx + 1;
            loadReport(idx);
          }).catch((err: any) => {
            console.log(err);
          });
        }
      };
      loadReport(0);
    });
    return promise;
  }

  loadReport(report: any) {
    const promise = new Promise<void>((resolve, reject) => {
      let idx: any = 0;
      let onUserStrategyLoaded = () => {
        report.strategies[idx].threads = this.user_strategies[report.strategies[idx].user_id];
        if ((idx + 1) >= report.strategies.length) {
          resolve(report);
        } else {
          idx = idx + 1;
          loadStrategy(idx);
        }
      };
      let loadStrategy = (idx: any) => {
        let move_next: any = false;
        if (!this.user_strategies[report.strategies[idx].user_id]) {
          let user: any = this.getAccountByUserId(report.strategies[idx].user_id);
          if (user) {
            this.listUserStrategies(user, onUserStrategyLoaded);
          } else {
            report.strategies[idx].threads = [];
            move_next = true;
          }
        } else {
          report.strategies[idx].threads = this.user_strategies[report.strategies[idx].user_id];
          move_next = true;
        }
        if (move_next) {
          if ((idx + 1) >= report.strategies.length) {
            resolve(report);
          } else {
            idx = idx + 1;
            loadStrategy(idx);
          }
        }
      };
      loadStrategy(idx);
    });
    return promise;
  }

  onAdd() {
    this.save_modal_report = { header: 'Add Report', btn_text: 'ADD', mode: 'add', report: {} };
    this.report_modal_form.patchValue({
      name: '',
      period: this.periods[0]._id
    });
    this.jq.openModal('saveReportModal');
  }

  onUpdate(report: any) {
    this.save_modal_report = { header: 'Update Report', btn_text: 'Update', mode: 'update', 'original': report, report: JSON.parse(JSON.stringify(report)) };
    let period: any = this.getPeriodById(report.type._id);
    if (!period) {
      this.notificationService.showAlert(CONSTANTS.ERROR, 'Unknown period configured in selected report.');
      return;
    }
    this.report_modal_form.patchValue({
      name: report.name,
      period: period._id
    });
    this.jq.openModal('saveReportModal');
  }

  onDelete(report: any) {
    this.jq.openModal('deleteReportConfirmationModal');
    this.deletion_report = report;
  }

  openSymbolSelection() {
    let ip: any = { broker: 'zerodha', segment: this.categories[1]._id, segment_type: this.segments[1]._id }
    this.listSymbols(ip, (symbols: any) => {
      this.select_symbol_params = {
        category: ip.segment,
        segment: ip.segment_type,
        symbols: symbols,
        symbol: symbols[1]._id,
      };
      this.jq.openModal('selectSymbolModal');
    });
  }

  deleteReport(confirmation: any) {
    if (confirmation == 1) {
      let input = { report_id: this.deletion_report.report_id };
      this.reportService.deleteReport(input).subscribe((response: any) => {
        this.notificationService.showAlert(CONSTANTS.SUCCESS, "Deleted successfully");
        this.deletion_report = null;
        this.jq.closeModal('deleteReportConfirmationModal')
        setTimeout(() => this.listReports(), 2000);
      });
    } else {
      this.deletion_report = null;
      this.jq.closeModal('deleteReportConfirmationModal')
    }
  }

  onModalClose(name: any, params: any) {
    if (name == 'save_report') {
      this.jq.closeModal('saveReportModal');
    } else if (name == 'view_report') {
      this.jq.closeModal('viewReportModal');
    } else if (name == 'select_symbol') {
      this.jq.closeModal('selectSymbolModal');
    }
  }

  onPeriodChanged() {

  }

  saveReport(params: any) {
    let ip: any = {
      name: this.report_modal_form.value.name,
      type: this.report_modal_form.value.period,
      strategies: params.report.strategies
    };
    if (params.mode == 'add') {
      this.reportService.add(ip).subscribe((response: any) => {
        this.notificationService.showAlert(CONSTANTS.SUCCESS, "Added successfully");
        this.jq.closeModal('saveReportModal')
        setTimeout(() => this.listReports(), 2000);
      });
    } else {
      ip['report_id'] = params.report.report_id;
      this.reportService.update(ip).subscribe((response: any) => {
        this.notificationService.showAlert(CONSTANTS.SUCCESS, "Added successfully");
        this.jq.closeModal('saveReportModal')
        setTimeout(() => this.listReports(), 2000);
      });
    }
  }

  onAddStrategy(params: any) {
    if (this.users.length <= 0) return;
    let user: any = this.users[0];
    let strategies: any = params.report.strategies || [];
    if (this.user_strategies[user.user._id]) {
      params.report.strategies = [];
      let strategy: any = this.create_strategy(strategies.length, user);
      strategies.push(strategy);
      params.report.strategies = strategies;
    } else {
      this.listUserStrategies(user, () => {
        params.report.strategies = [];
        let strategy: any = this.create_strategy(strategies.length, user);
        strategies.push(strategy);
        params.report.strategies = strategies;
      });
    }
  }

  create_strategy(idx: any, user: any) {
    let threads: any = this.user_strategies[user.user._id];
    let thread_id: any = threads[0]._id;
    return {
      id: idx,
      user_id: user.user._id == "-1" ? "" : user.user._id,
      thread_id: thread_id == "-1" ? "" : thread_id,
      threads: threads[0],
      capital: this.get_capital(threads[0]),
      entry_type: this.get_entry_type(threads[0]),
      input: this.get_default_input_type(thread_id)
    };
  }

  get_default_input_type(thread_id: any) {
    if (thread_id == "-1") {
      return this.input_types[2]._id;
    }
    return this.input_types[0]._id;
  }

  onUserChanged(strategy: any) {
    this.listUserStrategies(this.getAccountByUserId(strategy.user_id), () => {
      strategy.threads = this.user_strategies[strategy.user_id];
      strategy.entry_type = this.get_entry_type(strategy.threads[0]);
      strategy.thread_id = this.user_strategies[strategy.user_id][0]._id;
    });
  }

  onUserStrategyChanged(strategy: any) {
    let thread: any = this.getStrategyByUserStrategy(strategy.user_id, strategy.thread_id);
    strategy.entry_type = this.get_entry_type(thread);
  }

  onInputTypeChanged() {
  }

  should_disable(strategy: any) {
    let disable: any = !!strategy.thread_id && (strategy.thread_id != null) &&
    (strategy.thread_id != '') && (strategy.thread_id != "-1");
    return disable;
  }

  onDeleteRow(params: any, strategy: any) {
    let strategies: any = params.report.strategies || [];
    params.report.strategies = [];
    let idx: any = -1;
    for (let i = 0; i < strategies.length; i++) {
      if (strategies[i].id == strategy.id) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      strategies.splice(idx, 1);
    }
    params.report.strategies = strategies;
  }

  onStatusClick(event: any, report: any) {
    this.jq.openModal('enableReportConfirmationModal');
    this.enableParams = { 
      type: report.enabled ? 'disable' : 'enable',
      action: report.enabled ? 'Disable' : 'Enable',
      action_class: report.enabled ? { 'btn-danger': 1, 'btn-success': 0 } : { 'btn-danger': 0, 'btn-success': 1 },
      report: report,
      target: event.target
    };
  }

  updateReportStatus(confirmation: any, report: any) {
    if (confirmation == 1) {
      let data: any = { report_id: report.report_id, status: report.enabled ? 'inactive' : 'active' };
      this.reportService.update_status(data).subscribe((response: any) => {
        this.notificationService.showAlert(CONSTANTS.SUCCESS, `Report ${report.enabled ? 'Disabled' : 'Enabled'} Successfully`);
        this.jq.closeModal('enableReportConfirmationModal')
        this.listReports();
      });
    } else {
      this.enableParams.target.checked = report.enabled;
      this.enableParams = { type: '', action: '', action_class: {}, us: null } ;
      this.jq.closeModal('enableReportConfirmationModal')
    }
  }

  updateViewModalData(report: any, report_data: any) {
    let data: any = {}, keys: any = {}, rows: any;
    for (let idx = 0; idx < report.strategies.length; idx ++) {
      data = report_data[report.strategies[idx].strategy_id] || { 'ce': {}, 'pe': {} }, rows = [];
      keys = Object.keys(data);
      report.strategies[idx].no_data = false;
      report.strategies[idx].rows = [];
      for (let j = 0; j < keys.length; j++) {
        rows.push({
          strategy_id: data[keys[j]].strategy_id,
          strategy_name: data[keys[j]].strategy_name,
          symbol: data[keys[j]].symbol,
          strike_price: data[keys[j]].strike_price,
          option_type: keys[j].toUpperCase(),
          qty: data[keys[j]].qty,
          buy_price: data[keys[j]].buy_price,
          sell_price: data[keys[j]].sell_price,
        });
      }
      report.strategies[idx].rows = rows;
    }
    return report;
  }

  on_no_data(strategy: any) { }

  onDateChanged(params: any) {
    this.get_report_data(params.report, params.date, (response: any) => {
      let report: any = this.updateViewModalData(params.report, response.report_data);
      this.view_modal_report.report = report;
    });
  }

  onView(report: any) {
    let dt: any = this.dateUtil.yyyymmdd(new Date());
    this.get_report_data(report, dt, (response: any) => {
      let r: any = this.updateViewModalData(report, response.report_data);
      this.view_modal_report = { date: dt, report: r, generate_btn_txt: 'GENERATE', force: 0 };
      this.jq.openModal('viewReportModal');
    });
  }

  updateDatas(params: any) {
    let report_data: any = {}, tid: any, row: any;
    for (let idx = 0; idx < params.report.strategies.length; idx++) {
      if (params.report.strategies[idx].no_data) continue;
      tid = params.report.strategies[idx].strategy_id;
      report_data[tid] = report_data[tid] || {};
      for (let j = 0; j < params.report.strategies[idx].rows.length; j++) {
        row = params.report.strategies[idx].rows[j];
        report_data[tid][row.option_type.toLowerCase()] = {
          strategy_name: row.strategy_name,
          symbol: row.symbol,
          strike_price: row.strike_price,
          qty: row.qty,
          buy_price: row.buy_price,
          sell_price: row.sell_price,
        };
      }
    }
    let ip: any = {
      report_id: params.report.report_id,
      date: params.date,
      report_data: report_data
    };
    this.reportService.update_report_data(ip).subscribe((response: any) => {
      this.notificationService.showAlert(CONSTANTS.SUCCESS, 'Data Updated Successfully.');
      this.jq.closeModal('viewReportModal');
    });
  }

  generateReport(params: any) {
    let ip: any = {
      report_id: params.report.report_id,
      date: params.date,
      force: params.force
    };
    this.reportService.generate_report(ip).subscribe((response: any) => {
      this.notificationService.showAlert(CONSTANTS.SUCCESS, 'Report Generated Successfully.');
      this.jq.closeModal('viewReportModal');
    });
  }

  showReport(params: any) {
    let ip: any = {
      report_id: params.report.report_id,
      date: params.date,
    };
    this.reportService.download_report(ip).subscribe((response: any) => {
      this.jq.closeModal('viewReportModal');
    });
  }

  downloadReport(params: any) {
    let ip: any = {
      report_id: params.report.report_id,
      date: params.date,
    };
    this.reportService.download_report(ip).subscribe((response: any) => {
      this.notificationService.showAlert(CONSTANTS.SUCCESS, 'Report Downloaded Successfully.');
      this.jq.closeModal('viewReportModal');
    });
  }

  updateGenerateButton(params: any, name: any) {
    if (name == 'force') {
      params.generate_btn_txt = 'FORCE GENERATE';
      params.force = 1;
    } else {
      params.generate_btn_txt = 'GENERATE';
      params.force = 0;
    }
  }

  onSymbolSelected(params: any) {

  }

  onCategoryChanged(params: any) {
    let ip: any = { broker: 'zerodha', segment: params.category, segment_type: params.segment }
    this.listSymbols(ip, (symbols: any) => {
      this.select_symbol_params.symbols = symbols;
      this.select_symbol_params.symbol = symbols[1]._id;
    });
  }

  onSegmentChanged(params: any) {
    let ip: any = { broker: 'zerodha', segment: params.category, segment_type: params.segment }
    this.listSymbols(ip, (symbols: any) => {
      this.select_symbol_params.symbols = symbols;
      this.select_symbol_params.symbol = symbols[1]._id;
    });
  }

  get_capital(us: any) {
    if (us.strategy.name.toLowerCase() == 'lss_v1') {
      return us.strategy.config.capital[us.settings['straddle_type']]
    }
    return 0;
  }

  get_entry_type(us: any) {
    if (us?.strategy?.name.toLowerCase() == 'lss_v1') {
      return us?.settings?.straddle_type;
    } else {
      return us?.settings?.entry_type;
    }
  }

  get_user_name(user: any) {
    let acc: any = this.getAccountByUserId(user);
    if (acc) {
      return acc.user.full_name.toUpperCase();
    }
  }

  get_period_name(period: any) {
    return period?.name;
  }

  get_strategy_name(user: any, strategy: any) {
    let user_strategy: any = this.getStrategyByUserStrategy(user, strategy);
    if (user_strategy) {
      return user_strategy.display_name.toUpperCase();
    } 
  }

  get_input_type(strategy: any) {
    let ip_type: any = this.getInputTypeById(strategy.input);
    if (ip_type) {
      return ip_type.name.toUpperCase();
    }
  }

  getInputTypeById(input_type_id: any) {
    let idx: any = -1;
    for (let i = 0; i < this.input_types.length; i++) {
      if (this.input_types[i]._id == input_type_id) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      return this.input_types[idx];
    }
  }

  getPeriodById(period_id: any) {
    let idx: any = -1;
    for (let i = 0; i < this.periods.length; i++) {
      if (this.periods[i]._id == period_id) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      return this.periods[idx];
    }
  }

  getAccountByUserId(user_id: any) {
    let idx: any = -1;
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[i].user._id == user_id) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      return this.users[idx];
    }
  }

  getStrategyByUserStrategy(user: any, strategy: any) {
    let user_strategies: any = this.user_strategies[user];
    if (!user_strategies) return;
    let idx: any = -1;
    for (let i = 0; i < user_strategies.length; i++) {
      if (user_strategies[i]._id == strategy) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      return user_strategies[idx];
    }
  }

  get name() {
    return this.report_modal_form.get('name') as FormControl
  }

  get name_errors() {
    return (this.report_modal_form.get('name') as FormControl).errors as ValidationErrors
  }

  get period() {
    return this.report_modal_form.get('period') as FormControl
  }

  get period_errors() {
    return (this.report_modal_form.get('period') as FormControl).errors as ValidationErrors 
  }
}